import React from 'react';
import { cn } from '../../../../lib/utils';
import { SypacText } from '@sypac/component-library-react';
import { T } from '@tolgee/react';
import FormInput from './FormInput';

const ZoneHeader: React.FC<{
	index: number;
	formik: any;
	className?: string;
	editFormula: boolean;
}> = ({ index, formik, className = '', editFormula }) => {
	const zoneKeys = [
		'zoneZero',
		'zoneOne',
		'zoneTwo',
		'zoneThree',
		'zoneFour',
		'zoneFive',
	];
	const zoneLabels = [
		'Zone 0',
		'Zone 1',
		'Zone 2',
		'Zone 3',
		'Zone 4',
		'Zone 5',
	];

	return (
		<div
			className={cn(
				'w-full flex flex-col items-center justify-center gap-[22px]',
				className,
			)}
		>
			<SypacText variant="body-regular-medium">
				<p className="h-[24px] text-gray-80">
					<T keyName={`transportationFormula.${zoneKeys[index]}`}>
						{zoneLabels[index]}
					</T>
				</p>
			</SypacText>
			<FormInput
				name={`zones.distances[${index}].from`}
				placeholder="Enter value"
				className={cn(
					'w-full rounded-[8px] transition hover:bg-white focus:bg-white',
					index === 0 ? 'bg-[#FAFAFA]' : 'bg-[#E9F7F5]',
				)}
				formik={formik}
				readOnly={!editFormula}
			/>
		</div>
	);
};

export default ZoneHeader;
